import { Web3Provider } from '@ethersproject/providers';

export const connectWallet = async (setWalletAddress, setErrorMessage) => {
  if (window.ethereum) {
    try {
      const provider = new Web3Provider(window.ethereum);
      await window.ethereum.request({ method: 'eth_requestAccounts' });
      const signer = provider.getSigner();
      const address = await signer.getAddress();
      setWalletAddress(address);
      setErrorMessage("");
    } catch (err) {
      console.error("Error connecting to wallet:", err);
      setErrorMessage("Wallet connection failed.");
    }
  } else if (window.solana) {
    try {
      const { solana } = window;
      const address = await solana.connect();
      setWalletAddress(address.publicKey.toString());
      setErrorMessage("");
    } catch (err) {
      console.error("Phantom wallet connection failed:", err);
      setErrorMessage("Phantom wallet connection failed.");
    }
  } else {
    setErrorMessage("Please install MetaMask or Phantom.");
  }
};
